
    import './styles.scoped.css';
    export default {
  "options-list": "awsui_options-list_19gcf_11uoe_9",
  "options-list-embedded": "awsui_options-list-embedded_19gcf_11uoe_56",
  "decrease-block-margin": "awsui_decrease-block-margin_19gcf_11uoe_63"
};
  